import { render, staticRenderFns } from "./DevisClient.vue?vue&type=template&id=f48a1816"
import script from "./DevisClient.vue?vue&type=script&lang=js"
export * from "./DevisClient.vue?vue&type=script&lang=js"
import style0 from "./DevisClient.vue?vue&type=style&index=0&id=f48a1816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports